import React from 'react';

export const TableBody = ({ row, rowIndex, index, column }) => {
  return (
    <td style={column?.style}>
      {column?.cellRenderer && column?.cellRenderer(row, rowIndex, column)}
    </td>
  );
};
